// extracted by mini-css-extract-plugin
export var root = "modal-profile-module--root--dfce5";
export var window = "modal-profile-module--window--92e39";